import { Component, ViewEncapsulation } from "@angular/core";

@Component({
  selector: "masthead-complaints",
  encapsulation: ViewEncapsulation.Emulated,
  template: require('./complaints.component.html'),
  styles: [
    `
      :host {
        position: relative;
        padding-right: 10px;
      }

      :host::after {
        content: "";
        position: absolute;
        right: 0;
        width: 1px;
        height: 30px;
        bottom: 18px;
        background-color: #e5ebee;
      }

      .icon-speech-conversation::before {
        font-size: 25px;
      }
    `,
  ],
})
export class ComplaintsComponent {
  private environment: string;

  private complaintsUrl = new Map<string, string>([
    ["development", "https://web-staging.cib.digital/about-us/complaints/"],
    ["UAT", "https://web-staging.cib.digital/about-us/complaints/"],
    ["PPE", "https://cib.absa.africa/about-us/complaints/"],
    ["PROD", "https://cib.absa.africa/about-us/complaints/"],
  ]);

  constructor() {
    // get environment variable from api/configuration
    this.environment = JSON.parse(window["__CONFIGURATION"])["environment"] || "LOCAL";
  }

  clickLink() {
    window.open(this.complaintsUrl.get(this.environment), "_blank").focus();
  }
}



// WEBPACK FOOTER //
// node_modules/angular2-template-loader!./~/angular-router-loader/src!./src/app/threshold/components/complaints/complaints.component.ts